var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0901 8.74362L17.5557 7.26764C18.4912 8.47337 19.0733 9.8662 19.25 11.311H17.1504C17.0048 10.4067 16.641 9.52319 16.0901 8.74362ZM17.1504 13.3899H19.25C19.0733 14.8347 18.5016 16.2275 17.5661 17.4332L16.1005 15.9572C16.641 15.1777 17.0048 14.3046 17.1504 13.3899ZM16.1005 18.9196C14.8948 19.8551 13.4916 20.4164 12.0468 20.5931V18.483C12.9511 18.3271 13.8242 17.9737 14.6038 17.4124L16.1005 18.9196ZM9.96793 4.10779V0.916748L14.6973 5.64614L9.96793 10.2716V6.20743C7.01596 6.70635 4.7708 9.26334 4.7708 12.3504C4.7708 15.4375 7.01596 17.9945 9.96793 18.4934V20.5931C5.86219 20.0838 2.69195 16.5913 2.69195 12.3504C2.69195 8.10958 5.86219 4.6171 9.96793 4.10779Z",
    fill: "#E9731A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.c1f0761944b9c2b69a2fb918d3c1abe7.svg";
export { ForwardRef as ReactComponent };